<template>
  <v-container fluid>
      <v-card
        class="d-flex justify-center flex-column mx-auto my-6 flat"
        width="374"
        color="#fff"
      >
        <v-card-title class="d-flex justify-center pa-0 mt-2">
          個人設定
        </v-card-title>
        <v-card-text class="d-flex justify-center flex-column">
          <v-row class="justify-center">
            <v-col cols="6" justify="start">
              ログインユーザー
            </v-col>
            <v-col cols="6" justify="end">
              {{ userNm }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
//import { httpsCallable, getFunctions } from "firebase/functions";
export default {
  data() {
    return {
      userNm: "",
    };
  },
  // 初期表示時データ読み込み
  async created() {

  },
  methods: {
  },
};
</script>